// extracted by mini-css-extract-plugin
export default {"label":"UserCreateLabel_label__w6U4I","leftBox":"UserCreateLabel_leftBox__3l6aq","colorBlock":"UserCreateLabel_colorBlock__xNd41"};